import React, { useState, useEffect } from 'react';
import { Search, ExternalLink } from 'lucide-react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import '../styles/Shop.css';
import { GetAllData } from '@/firebase/functions';
import { FaYoutube, FaDiscord } from "react-icons/fa";


const Shop = () => {
  const [selectedCategory, setSelectedCategory] = useState('All Products');
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [isVisible, setIsVisible] = useState(true);
  const [categories, setcategories] = useState([])
  const [response, setresponse] = useState([])



  useEffect(() => {
    GetAllData('products').then(({ docs }) => {
      const data = []
      docs.forEach(v => {
        data.push({ ...v.data(), id: v.id })
      })
      setFilteredProducts(data)
      setresponse(data)
      setIsVisible(false)
    }).catch(err => {
      console.log('get product: ', err);
      setIsVisible(false)
    })
    GetAllData('toics').then(({ docs }) => {
      const data = []
      docs.forEach(v => {
        data.push({ ...v.data(), id: v.id })
      })
      setIsVisible(false)
      setcategories(data)
    }).catch(err => {
      setIsVisible(false)
      console.log('get topics: ', err);
    })
  }, []);

  const handleCardClick = (link) => {
    window.open(link, '_blank', 'noopener,noreferrer');
  };

  function searchByTitle(value) {
    setSearchQuery(value)
    if (!value) {
      setFilteredProducts(response)
      return
    }
    const filteredData = response.filter(a => a?.title?.includes(value))
    setFilteredProducts(filteredData)
  }

  function filterByTopics(name) {
    setSelectedCategory(name)
    if (name === 'All Products') {
      setFilteredProducts(response)
      return
    }
    const filteredData = response.filter(a => a?.tag?.includes(name))
    setFilteredProducts(filteredData)
  }

  return (
    <div className="shop-container">
      {/* Header */}
      <header className="shop-header">
        <div className="header-content">
          <div className="logo-section">
            <h1 className="studio-name">Senpai Central Studio</h1>
            <p className="studio-tagline">Your Anime Paradise</p>
          </div>
          <div className="social-links">
            <a href="https://www.youtube.com/@SenpaiCentralStudio" target="_blank" rel="noopener noreferrer" className="social-icon youtube">
              <FaYoutube size={20} />
            </a>
            <a href="https://discord.gg/BczXcmJ7xx" target="_blank" rel="noopener noreferrer" className="social-icon discord">
              <FaDiscord size={20} />
            </a>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className={`hero-section visible`}>
        <div className="hero-content">
          <h2 className="hero-title">Discover Amazing Products</h2>
          <p className="hero-subtitle">Explore our exclusive collection of anime merchandise, digital art, and more</p>
        </div>
      </section>

      {/* Filter & Search Section */}
      <section className="filter-section">
        <div className="filter-container">
          <div className="search-wrapper">
            <Search className="search-icon" size={18} />
            <Input
              type="text"
              placeholder="Search products..."
              value={searchQuery}
              onChange={(e) => searchByTitle(e.target.value)}
              className="search-input"
            />
          </div>
          <div className="category-filters">
            {/* <Filter size={18} className="filter-icon" /> */}
            {isVisible && <div className='text-sm'>Loading.....</div>}
            {categories.map((category) => (
              <Button
                key={category.id}
                onClick={() => filterByTopics(category.name)}
                className={`category-btn capitalize ${selectedCategory === category.name ? 'active' : ''}`}
                variant={selectedCategory === category.id ? 'default' : 'outline'}
              >
                {category.name}
              </Button>
            ))}
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="products-section">
        <div className="products-grid">
          {filteredProducts.length === 0 ? (
            <div className="no-products">
              <p>No products found. Try a different search or category.</p>
            </div>
          ) : (
            filteredProducts.map((product, index) => (
              <Card
                key={product.id}
                className="product-card"
                style={{ animationDelay: `${index * 0.08}s` }}
                onClick={() => handleCardClick(product.link)}
              >
                <div className="card-image-wrapper">
                  <img src={product.image} alt={product.title} className="product-image" />
                  <div className="card-overlay">
                    <ExternalLink size={28} className="overlay-icon" />
                  </div>
                </div>
                <CardContent className="card-content">
                  <div className='flex justify-start items-center gap-2 flex-wrap'>
                    {
                      product?.tag?.map(v => <Badge className="category-badge">{v}</Badge>)
                    }
                  </div>
                  <h3 className="product-name">{product.title}</h3>
                  <p className="product-description">{product.description}</p>
                </CardContent>
              </Card>
            ))
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="shop-footer">
        <div className="footer-content">
          <p className="footer-text">© 2025 Senpai Central Studio. All rights reserved.</p>
          <div className="footer-social">
            <a href="https://www.youtube.com/@SenpaiCentralStudio" target="_blank" rel="noopener noreferrer" className="footer-social-link">
              <FaYoutube size={18} />
            </a>
            <a href="https://discord.gg/BczXcmJ7xx" target="_blank" rel="noopener noreferrer" className="footer-social-link">
              <FaDiscord size={18} />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Shop;